import { Vector3 } from "three";

export const popupData = {
    1: {
        position: new Vector3(0, 125, 0),
        // title: "Lets practice on this Mock floorplan",
        title: (
            <>
                Let's get started with this <strong><u>mock floorplan</u></strong> practice.
            </>
        ),
        buttonText1: "Yes",
        order: "1 / 9",
        showArrow: "bottom",
    },
    2: {
        className: "selectWallPopup",
        // title: "Lets start by selecting the wall Option",
        title: (
            <>Select the <strong><u>Wall</u></strong> option from the menu to begin drawing.</>
        ),
        order: "2 / 9",
    },
    3: {
        position: "customised",
        // title: "Click on the EDGE of the Layout to start",
        title: (
            <>Click on the <strong><u>edge of the layout</u></strong> to place your starting point.</>
        ),
        order: "3 / 9",
        showArrow: "top",
    },
    4: {
        position: "customised",
        // title: "Click on the EDGE of wall to finish the Wall",
        title: (
            <>
            Click again on the <strong><u>next edge</u></strong> to finish your first wall.
            </>
        ),
        showArrow: "top",
        order: "4 / 9",
    },
    5: {
        position: "customised",
        // title: "Always make a stop at Junction before continuing",
        title: (
            <>Make a <strong><u>stop at every corner</u></strong> (junction) before continuing the line.</>
        ),
        showArrow: "right",
        order: "5 / 9",
    },
    6: {
        position: "customised",
        // title: "After Drawing the Line you can change it to other types “ Click on WINDOW to change the line to window “",
        title: (
            <>Great! Click on <strong><u>Window</u></strong> to convert this line into a window.</>
        ),
        showArrow: "right",
        order: "6 / 9"
    },
    7: {
        position: "customised",
        // title: "After Drawing the Line you can change it to other types “ Click on DOOR to change the line to DOOR “",
        title: (
            <>Now click on <strong><u>Door</u></strong> to turn this line into a door. You’re doing great!</>
        ),
        showArrow:"bottom",
        order: "7 / 9"
    },
    8: {
        position: "customised",
        // title: "Now Complete the Room with Wall",
        title: (
            <>Complete the room by connecting back with <strong><u>Wall</u></strong> lines.</>
        ),
        showArrow:"left",
        order: "8 / 9"
    },
    9: {
        position: "customised",
        // title: "Click on Stop Drawing after completing the drawing",
        title: (<>
        All set! Tap <strong><u>Stop Drawing</u></strong> to finish mock floorplan practice.
        </>),
        showArrow: "bottom",
        order: "9 / 9"
    }
};
